"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingField = exports.MissingFields = exports.ConditionNotFound = exports.ThresholdNotFound = exports.JurisdictionNotFound = void 0;
class JurisdictionNotFound extends Error {
    constructor(message) {
        super(message);
        this.name = 'JurisdictionNotFound';
    }
}
exports.JurisdictionNotFound = JurisdictionNotFound;
class ThresholdNotFound extends Error {
    constructor(message) {
        super(message);
        this.name = 'ThresholdNotFound';
    }
}
exports.ThresholdNotFound = ThresholdNotFound;
class ConditionNotFound extends Error {
    constructor(message) {
        super(message);
        this.name = 'ConditionNotFound';
    }
}
exports.ConditionNotFound = ConditionNotFound;
class MissingFields extends Error {
    constructor(type, fields) {
        super('Threshold condition failed');
        this.name = 'MissingFields';
        this.type = type;
        this.fields = fields;
    }
    getMissingFields() {
        return {
            type: this.type,
            fields: this.fields.map((f) => {
                if (f instanceof MissingField)
                    return f.field;
                return f.getMissingFields();
            }),
        };
    }
}
exports.MissingFields = MissingFields;
class MissingField extends Error {
    constructor(message, field) {
        super(message);
        this.name = 'MissingField';
        this.field = field;
    }
}
exports.MissingField = MissingField;
